// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Z_3sO","topBottomGutter":"Layout_topBottomGutter__21BvP"};